// getRowsFromServer の無検証 as キャストをやめ、生成済み zod スキーマで safeParse する共通ラッパ。
// 検証は行単位で行い、不一致行のみ除外する。配列全体を z.array で一括検証すると1行の型ズレで
// 全件が失われ材料名等が全滅する(#id 表示に劣化する)ため、部分劣化に留める。
import { ZodTypeAny, z } from "zod";
import { AuthedApi } from "../api/Api";
import { EntityGetPlural } from "../api/IndexedDB/generated/entityDefs";

export async function getRowsChecked<Schema extends ZodTypeAny>(
  api: AuthedApi,
  slug: EntityGetPlural,
  rowSchema: Schema
): Promise<z.infer<Schema>[]> {
  const rawRows = await api.getRowsFromServer(slug);
  if (!Array.isArray(rawRows)) {
    console.warn(`${slug} の取得結果が配列ではありません`, rawRows);
    api.showError(`${slug} の取得結果が不正です。管理者にお問い合わせください。`);
    return [];
  }
  const validRows: z.infer<Schema>[] = [];
  let invalidCount = 0;
  for (const raw of rawRows) {
    const parsed = rowSchema.safeParse(raw);
    if (parsed.success) {
      validRows.push(parsed.data);
    } else {
      invalidCount = invalidCount + 1;
    }
  }
  if (invalidCount > 0) {
    console.warn(`${slug}: ${invalidCount}/${rawRows.length} 件がスキーマと不一致のため除外しました`);
    api.showError(`${slug} の一部データが不正です(${invalidCount}件を除外)。管理者にお問い合わせください。`);
  }
  return validRows;
}
